import { render, staticRenderFns } from "./SelectedData.vue?vue&type=template&id=202c7ecb&scoped=true"
import script from "./SelectedData.vue?vue&type=script&lang=js"
export * from "./SelectedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202c7ecb",
  null
  
)

export default component.exports